import { createContext } from 'react';
import { IUser } from '../../types/User.interface';

const UserContext = createContext<null | IUser>(null);

export default UserContext;
